import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from "react-select";
import { toast } from 'react-hot-toast';
import { faPhone, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope, faUser, faIdBadge } from '@fortawesome/free-regular-svg-icons'

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Profile({selectedUser}) {
    const [fullname, setFullname] = useState(selectedUser?.fullname);
    const [country, setCountry] = useState(selectedUser?.country);
    const [phone, setPhone] = useState(selectedUser?.phone);

    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const [files, setFiles] = useState([]);
    const [fileName, setFileName] = useState(selectedUser?.photo);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    const countryoptions = [
        { value: "Afghanistan", label: "Afghanistan" },
        { value: "Albania", label: "Albania" },
        { value: "Algeria", label: "Algeria" },
        { value: "Andorra", label: "Andorra" },
        { value: "Angola", label: "Angola" },
        { value: "Antigua-and-barbuda", label: "Antigua and Barbuda" },
        { value: "Argentina", label: "Argentina" },
        { value: "Armenia", label: "Armenia" },
        { value: "Australia", label: "Australia" },
        { value: "Austria", label: "Austria" },
        { value: "Azerbaijan", label: "Azerbaijan" },
        { value: "Bahamas", label: "Bahamas" },
        { value: "Bahrain", label: "Bahrain" },
        { value: "Bangladesh", label: "Bangladesh" },
        { value: "Barbados", label: "Barbados" },
        { value: "Belarus", label: "Belarus" },
        { value: "Belgium", label: "Belgium" },
        { value: "Belize", label: "Belize" },
        { value: "Benin", label: "Benin" },
        { value: "Bhutan", label: "Bhutan" },
        { value: "Bolivia", label: "Bolivia" },
        { value: "Bosnia-and-herzegovina", label: "Bosnia and Herzegovina" },
        { value: "Botswana", label: "Botswana" },
        { value: "Brazil", label: "Brazil" },
        { value: "Brunei", label: "Brunei" },
        { value: "Bulgaria", label: "Bulgaria" },
        { value: "Burkina-faso", label: "Burkina Faso" },
        { value: "Burundi", label: "Burundi" },
        { value: "Cambodia", label: "Cambodia" },
        { value: "Cameroon", label: "Cameroon" },
        { value: "Canada", label: "Canada" },
        { value: "Cape-verde", label: "Cape Verde" },
        { value: "Central-african-republic", label: "Central African Republic" },
        { value: "Chad", label: "Chad" },
        { value: "Chile", label: "Chile" },
        { value: "China", label: "China" },
        { value: "Colombia", label: "Colombia" },
        { value: "Comoros", label: "Comoros" },
        { value: "Congo", label: "Congo" },
        { value: "Costa-rica", label: "Costa Rica" },
        { value: "Croatia", label: "Croatia" },
        { value: "Cuba", label: "Cuba" },
        { value: "Cyprus", label: "Cyprus" },
        { value: "Czech-republic", label: "Czech Republic" },
        { value: "Denmark", label: "Denmark" },
        { value: "Djibouti", label: "Djibouti" },
        { value: "Dominica", label: "Dominica" },
        { value: "Dominican-republic", label: "Dominican Republic" },
        { value: "Ecuador", label: "Ecuador" },
        { value: "Egypt", label: "Egypt" },
        { value: "El-salvador", label: "El Salvador" },
        { value: "Equatorial-guinea", label: "Equatorial Guinea" },
        { value: "Eritrea", label: "Eritrea" },
        { value: "Estonia", label: "Estonia" },
        { value: "Eswatini", label: "Eswatini" },
        { value: "Ethiopia", label: "Ethiopia" },
        { value: "Fiji", label: "Fiji" },
        { value: "Finland", label: "Finland" },
        { value: "France", label: "France" },
        { value: "Gabon", label: "Gabon" },
        { value: "Gambia", label: "Gambia" },
        { value: "Georgia", label: "Georgia" },
        { value: "Germany", label: "Germany" },
        { value: "Ghana", label: "Ghana" },
        { value: "Greece", label: "Greece" },
        { value: "Grenada", label: "Grenada" },
        { value: "Guatemala", label: "Guatemala" },
        { value: "Guinea", label: "Guinea" },
        { value: "Guinea-bissau", label: "Guinea-Bissau" },
        { value: "Guyana", label: "Guyana" },
        { value: "Haiti", label: "Haiti" },
        { value: "Honduras", label: "Honduras" },
        { value: "Hungary", label: "Hungary" },
        { value: "Iceland", label: "Iceland" },
        { value: "India", label: "India" },
        { value: "Indonesia", label: "Indonesia" },
        { value: "Iran", label: "Iran" },
        { value: "Iraq", label: "Iraq" },
        { value: "Ireland", label: "Ireland" },
        { value: "Israel", label: "Israel" },
        { value: "Italy", label: "Italy" },
        { value: "Jamaica", label: "Jamaica" },
        { value: "Japan", label: "Japan" },
        { value: "Jordan", label: "Jordan" },
        { value: "Kazakhstan", label: "Kazakhstan" },
        { value: "Kenya", label: "Kenya" },
        { value: "Kiribati", label: "Kiribati" },
        { value: "Korea-north", label: "North Korea" },
        { value: "Korea-south", label: "South Korea" },
        { value: "Kosovo", label: "Kosovo" },
        { value: "Kuwait", label: "Kuwait" },
        { value: "Kyrgyzstan", label: "Kyrgyzstan" },
        { value: "Laos", label: "Laos" },
        { value: "Latvia", label: "Latvia" },
        { value: "Lebanon", label: "Lebanon" },
        { value: "Lesotho", label: "Lesotho" },
        { value: "Liberia", label: "Liberia" },
        { value: "Libya", label: "Libya" },
        { value: "Liechtenstein", label: "Liechtenstein" },
        { value: "Lithuania", label: "Lithuania" },
        { value: "Luxembourg", label: "Luxembourg" },
        { value: "Madagascar", label: "Madagascar" },
        { value: "Malawi", label: "Malawi" },
        { value: "Malaysia", label: "Malaysia" },
        { value: "Maldives", label: "Maldives" },
        { value: "Mali", label: "Mali" },
        { value: "Malta", label: "Malta" },
        { value: "Marshall-islands", label: "Marshall Islands" },
        { value: "Mauritania", label: "Mauritania" },
        { value: "Mauritius", label: "Mauritius" },
        { value: "Mexico", label: "Mexico" },
        { value: "Micronesia", label: "Micronesia" },
        { value: "Moldova", label: "Moldova" },
        { value: "Monaco", label: "Monaco" },
        { value: "Mongolia", label: "Mongolia" },
        { value: "Montenegro", label: "Montenegro" },
        { value: "Morocco", label: "Morocco" },
        { value: "Mozambique", label: "Mozambique" },
        { value: "Myanmar", label: "Myanmar" },
        { value: "Namibia", label: "Namibia" },
        { value: "Nauru", label: "Nauru" },
        { value: "Nepal", label: "Nepal" },
        { value: "Netherlands", label: "Netherlands" },
        { value: "New-zealand", label: "New Zealand" },
        { value: "Nicaragua", label: "Nicaragua" },
        { value: "Niger", label: "Niger" },
        { value: "Nigeria", label: "Nigeria" },
        { value: "North-macedonia", label: "North Macedonia" },
        { value: "Norway", label: "Norway" },
        { value: "Oman", label: "Oman" },
        { value: "Pakistan", label: "Pakistan" },
        { value: "Palau", label: "Palau" },
        { value: "Panama", label: "Panama" },
        { value: "Papua-new-guinea", label: "Papua New Guinea" },
        { value: "Paraguay", label: "Paraguay" },
        { value: "Peru", label: "Peru" },
        { value: "Philippines", label: "Philippines" },
        { value: "Poland", label: "Poland" },
        { value: "Portugal", label: "Portugal" },
        { value: "Qatar", label: "Qatar" },
        { value: "Romania", label: "Romania" },
        { value: "Russia", label: "Russia" },
        { value: "Rwanda", label: "Rwanda" },
        { value: "Saint-kitts-and-nevis", label: "Saint Kitts and Nevis" },
        { value: "Saint-lucia", label: "Saint Lucia" },
        { value: "Saint-vincent-and-the-grenadines", label: "Saint Vincent and the Grenadines" },
        { value: "Samoa", label: "Samoa" },
        { value: "San-marino", label: "San Marino" },
        { value: "Sao-tome-and-principe", label: "Sao Tome and Principe" },
        { value: "Saudi-arabia", label: "Saudi Arabia" },
        { value: "Senegal", label: "Senegal" },
        { value: "Serbia", label: "Serbia" },
        { value: "Seychelles", label: "Seychelles" },
        { value: "Sierra-leone", label: "Sierra Leone" },
        { value: "Singapore", label: "Singapore" },
        { value: "Slovakia", label: "Slovakia" },
        { value: "Slovenia", label: "Slovenia" },
        { value: "Solomon-islands", label: "Solomon Islands" },
        { value: "Somalia", label: "Somalia" },
        { value: "South-africa", label: "South Africa" },
        { value: "South-sudan", label: "South Sudan" },
        { value: "Spain", label: "Spain" },
        { value: "Sri-lanka", label: "Sri Lanka" },
        { value: "Sudan", label: "Sudan" },
        { value: "Suriname", label: "Suriname" },
        { value: "Sweden", label: "Sweden" },
        { value: "Switzerland", label: "Switzerland" },
        { value: "Syria", label: "Syria" },
        { value: "Taiwan", label: "Taiwan" },
        { value: "Tajikistan", label: "Tajikistan" },
        { value: "Tanzania", label: "Tanzania" },
        { value: "Thailand", label: "Thailand" },
        { value: "Togo", label: "Togo" },
        { value: "Tonga", label: "Tonga" },
        { value: "Trinidad-and-tobago", label: "Trinidad and Tobago" },
        { value: "Tunisia", label: "Tunisia" },
        { value: "Turkey", label: "Turkey" },
        { value: "Turkmenistan", label: "Turkmenistan" },
        { value: "Tuvalu", label: "Tuvalu" },
        { value: "Uganda", label: "Uganda" },
        { value: "Ukraine", label: "Ukraine" },
        { value: "United-arab-emirates", label: "United Arab Emirates" },
        { value: "United-kingdom", label: "United Kingdom" },
        { value: "United-states", label: "United States" },
        { value: "Uruguay", label: "Uruguay" },
        { value: "Uzbekistan", label: "Uzbekistan" },
        { value: "Vanuatu", label: "Vanuatu" },
        { value: "Vatican-city", label: "Vatican City" },
        { value: "Venezuela", label: "Venezuela" },
        { value: "Vietnam", label: "Vietnam" },
        { value: "Yemen", label: "Yemen" },
        { value: "Zambia", label: "Zambia" },
        { value: "Zimbabwe", label: "Zimbabwe" },
        { value: "Crypto", label: "Crypto" }
    ];
    useEffect(() => {
        if(fullname && country && phone){
          setDisable(false);
        }else{
          setDisable(true);
        }
      }, [fullname, country, phone]);
    const ValidateSave = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ profileupdate: true, email: selectedUser?.email, fullname: fullname, country: country, phone: phone, photo: fileName })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    return (
        <div>
            <p className="fw-bold mb-0">User</p>
            <p className="mb-0" style={{fontSize:'14px'}}>Edit profile photo and other account info.</p>
            <div className="mt-3 rounded-4 p-1" style={{backgroundColor:'rgba(255,255,255,0.03)',cursor:'pointer'}}>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.fullname}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover lh-1 rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faIdBadge} style={{fontSize: '16px'}} className="me-1" /> @{selectedUser.username}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faEnvelope} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.email}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faPhone} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.phone}</p>
            </div>
            </div>
            <p className="mt-5 fw-bold mb-0">Profile</p>
            <p className="mb-4" style={{fontSize:'14px'}}>Leave a field unchanged to retain its value.</p>
            <label className="fw-semibold" style={{fontSize: '13px'}}>Profile picture:</label>
            <FilePond
                files={files}
                onupdatefiles={setFiles}
                allowMultiple={false}
                maxFiles={3}
                name="file"
                labelIdle="Click here to upload"
                server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append("file", file);
                    const request = new XMLHttpRequest();
                    request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                    request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                        setFileName(res.filename);
                        load(res.filename);
                    } else {
                        error(res.error || "Upload failed");
                    }
                    };
                    request.onerror = () => {
                    error("Upload error");
                    };
                    request.send(formData);
                    return {
                    abort: () => {
                        request.abort();
                        abort();
                    }
                    };
                },
                revert: (serverId, load, error) => {
                    fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: fileName })
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.success) {
                        setFileName("");
                        setFiles([]);
                        load();
                        } else {
                        error(data.error || "Failed to delete file");
                        }
                    })
                    .catch(() => {
                        error("Delete request failed");
                    });
                }
                }}
            />
            <label className="fw-semibold my-2" style={{fontSize: '14px'}}>Country:</label>
            <Select 
                options={countryoptions} 
                value={countryoptions.find((opt) => opt.value === country)}
                onChange={(e) => setCountry(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Fullname:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type="text"
                    placeholder={fullname}
                    className="inputNone"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                />
            </div>
            <label className="fw-semibold my-2" style={{fontSize: '14px'}}>Phone number:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type="text"
                    placeholder={phone}
                    className="inputNone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
            </div>
            <div className={`myBtn w-100 text-center my-5 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateSave : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
        </div>
    )
}

export default Profile